import React, { Component } from 'react';
import * as _ from 'lodash';
import { Field, FieldArray } from 'formik';
import PropTypes from 'prop-types';

import FieldUtil from '../utils/FieldNames';
import '../../../../app/assets/stylesheets/rte_edit_payer.scss';
import { stubAccumNode } from '../utils/convert-to-editable';


class DataSection extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ebSegmentParents = {};
  }

  isRequired(fieldName) {
    return fieldName === 'service_type_code'
      || fieldName === 'time_period'
      || fieldName === 'in_network';
  }

  renderAccumSection({ fields, sectionTitle, toolbar = _.noop, path, isViewMode }) {
    return (
      <div className="accumSubKeyDiv">
        <div className="accumSubKey">
          <div className="accumSubKey">
            {sectionTitle()}
            {!isViewMode &&
            <div className="accumNodeToolbar">{toolbar()}</div>
            }
          </div>
        </div>
        {fields.map((fieldName, i) => (
          <div key={`accumfield${i}`} className="accumSubKeyFieldDiv">
            <div className="accumSubKeyField">
              <span className="accum_subkey_field_span">
                {FieldUtil.transformName(fieldName)}
              </span>
              <Field
                name={`${path}.${fieldName}`}
                render={({ field, form }) => (
                  <div className="input_div">
                    <input {...field} onChange={this.props.handleChange} disabled={isViewMode} className="accum_subkey_field_input" />
                    {this.isRequired(field) &&
                    <span className="required_asterisk">*</span>
                    }
                    <span className="error_container">
                      {_.get(form.touched, field.name) &&
                      FieldUtil.transformErrorMessage(_.get(form.errors, field.name))
                      }
                    </span>
                  </div>
                )}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderAccum({ accum, accums, path, key, isViewMode, arrayHelpers }) {
    const configFilters = _.get(accum, 'custom_filters');
    const availableFilters = this.props.availableFilters;
    return (
      <div className="accum" key={`accum${key}`}>

        {this.renderAccumSection({
          isViewMode,
          path:         `${path}.eb_fields`,
          fields:       FieldUtil.accumSubKeyFields.eb_fields,
          sectionTitle: () => <b>Eb Fields</b>,
          toolbar:      () => (
            <span>
              <a onClick={() => arrayHelpers.push(_.cloneDeep(accum))}>
                Duplicate
              </a>
              {accums.length > 1 &&
              <a onClick={() => arrayHelpers.remove(key)}>
                Remove
              </a>
              }
            </span>
          )
        })}

        {this.renderAccumSection({
          isViewMode,
          path:         `${path}.messages`,
          fields:       FieldUtil.accumSubKeyFields.messages,
          sectionTitle: () => <b>Messages</b>
        })}

        <div className="accum_subkey_custom_filters accumSubKeyDiv">
          <div className="accum_subkey custom_filters">
            <b className="accum_subkey_custom_filters_span">Custom Filters</b>
            <FieldArray
              name={`${path}.custom_filters`}
              render={arrayHelpers => (
                <div className="custom_filter_div">
                  { configFilters ? (
                    configFilters.map((filter, index) => (
                      <div key={`filter${index}`}>
                        <Field component="select" name={`${path}.custom_filters.${index}`} onChange={this.props.handleChange} disabled={isViewMode} className="select-style">
                          {availableFilters.map(({ value, text }) => <option key={value} value={value}>{text}</option>)}
                        </Field>
                        <button type="button" onClick={() => { arrayHelpers.push(''); }}      disabled={configFilters.includes('') || isViewMode} >+</button> { /* insert a new availableFilters selectbox*/ }
                        <button type="button" onClick={() => { arrayHelpers.remove(index); }} disabled={configFilters.length === 1 || isViewMode}>-</button> {/* remove a filter from the list */}
                      </div>
                    ))
                  ) : (
                    arrayHelpers.push('')
                  )}
                </div>
              )}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const accums = _.get(this.props.values, `payer_config.payer_config_settings.${this.props.visibleSection}`);
    const [, visibleSpecialty, visibleAccum] = this.props.visibleSection.split('.');
    const isViewMode = this.props.mode !== 'edit';
    return (
      <section>
        <div className="cost_rules">
          <b className="specialty_key_field">{FieldUtil.transformName(visibleSpecialty)}</b>
        </div>
        <div className="--rules--">
          <div className="accum_keys">
            <div className="payment_methods accumDiv">
              <b>{FieldUtil.transformName(visibleAccum)}</b>
            </div>
          </div>
          <FieldArray
            name={`payer_config.payer_config_settings.two_seventy_one.${visibleSpecialty}.${visibleAccum}`}
            render={arrayHelpers => (
              <div className="--accums--">
                {accums.map((accum, i) => (
                  this.renderAccum({
                    accum,
                    accums,
                    arrayHelpers,
                    isViewMode,
                    key:  i,
                    path: `payer_config.payer_config_settings.two_seventy_one.${visibleSpecialty}.${visibleAccum}.${i}`
                  })
                ))}
              </div>
            )}
          />
        </div>
      </section>
    );
  }
}

DataSection.propTypes = {
  mode:              PropTypes.string,
  visibleSection:    PropTypes.string,
  visible:           PropTypes.object,
  values:            PropTypes.object,
  initialDataValues: PropTypes.object,
  handleChange:      PropTypes.func,
  availableFilters:  PropTypes.array
};

export default DataSection;
